var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M22.394 7.103l-1.98 1.98a.515.515 0 01-.731 0l-4.77-4.769a.515.515 0 010-.73l1.98-1.981a2.068 2.068 0 012.919 0l2.582 2.582a2.06 2.06 0 010 2.918zm-9.183-1.818L1.927 16.57l-.91 5.221a1.032 1.032 0 001.194 1.195l5.22-.916 11.285-11.284a.515.515 0 000-.73l-4.77-4.77a.521.521 0 00-.735 0zm-8.43 13.931h2.062v1.56l-2.772.486-1.336-1.337.486-2.771h1.56v2.062z"
  }))));
}

export default SvgPencil;